module.exports = __webpack_public_path__ + "img/10-3.7348fc0b.png";